import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaLinkedin,
  FaEnvelope,
  FaQuoteLeft,
  FaTruckMoving,
  FaUsers,
  FaGlobe,
  FaAward,
} from "react-icons/fa";

const leaders = [
  {
    name: "Suresh Agarwal",
    role: "Founder & Managing Director",
    initials: "SA",
    image: "",
    message:
      "When I started Paras Roadlines in 1986 with a single truck, my only vision was to deliver goods safely and on time. Today, seeing our fleet of 250+ vehicles serving 100+ cities fills me with immense pride. But what truly matters is the trust our clients place in us — that's what drives us to improve every single day.",
  },
  {
    name: "Rakesh Nair",
    role: "Chief Operating Officer",
    initials: "RN",
    image: "",
    message:
      "Operations is the backbone of any logistics company. My focus has always been on building systems that ensure every shipment is tracked, every route is optimized, and every delivery is on time. Our 98% on-time rate isn't just a number — it's a promise we keep every day to our partners across India.",
  },
];
const team = [
  {
    name: "Anjali Deshmukh",
    role: "Head of Customer Relations",
    initials: "AD",
  },
  {
    name: "Manoj Tiwari",
    role: "Warehousing & Logistics Manager",
    initials: "MT",
  },
  {
    name: "Kavita Rao",
    role: "Finance & Accounts Manager",
    initials: "KR",
  },
  {
    name: "Vikram Singh",
    role: "Route Planning Lead",
    initials: "VS",
  },
];

const stats = [
  { icon: <FaTruckMoving />, value: "250+", label: "Fleet Vehicles" },
  { icon: <FaUsers />, value: "10,000+", label: "Happy Clients" },
  { icon: <FaGlobe />, value: "100+", label: "Cities Covered" },
  { icon: <FaAward />, value: "98%", label: "On-Time Rate" },
];

function OurTeam() {
  const navigate = useNavigate();

  return (
    <div className="ot-page" style={{ paddingTop: "68px" }}>
      {/* ══ HERO ══ */}
      <section className="ot-hero-sec">
        <div className="ot-hero-bg" />
        <div className="ot-hero-content">
          <div className="ot-tag-row">
            <span className="ot-tag-line-light" />
            <span className="ot-tag-light">Our Team</span>
            <span className="ot-tag-line-light" />
          </div>
          <h1>The People Behind<br />Every Delivery</h1>
          <p>
            A dedicated team driving reliable, efficient, and transparent
            logistics across India since 1986.
          </p>
          <div className="ot-hero-stats">
            {stats.map(({ icon, value, label }) => (
              <div className="ot-hstat" key={label}>
                <div className="ot-hstat-icon">{icon}</div>
                <span className="ot-hstat-num">{value}</span>
                <span className="ot-hstat-lbl">{label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ LEADERSHIP ══ */}
      <section className="ot-leaders-sec">
        <div className="ot-container">
          <div className="ot-sec-hdr">
            <div className="ot-tag-row">
              <span className="ot-tag-line" />
              <span className="ot-tag">Leadership</span>
              <span className="ot-tag-line" />
            </div>
            <h2>Meet Our Visionaries</h2>
            <p>The leaders who shaped Paras Roadlines into what it is today</p>
          </div>
{leaders.map((leader, idx) => (
  <div
    className={`ot-leader-block ${idx % 2 !== 0 ? "ot-leader-reverse" : ""}`}
    key={leader.name}
  >
    {/* Photo */}
    <div className="ot-leader-photo-wrap">
      <div className="ot-leader-photo">
        {leader.image ? (
          <img src={leader.image} alt={leader.name} />
        ) : (
          <div className="ot-leader-avatar">{leader.initials}</div>
        )}
      </div>
    </div>

    {/* Info */}
    <div className="ot-leader-info">
      <span className="ot-leader-role-tag">{leader.role}</span>
      <h3>{leader.name}</h3>
      <div className="ot-leader-quote">
        <FaQuoteLeft className="ot-quote-icon" />
        <p>{leader.message}</p>
      </div>
    </div>
  </div>
))}
        </div>
      </section>

      {/* ══ TEAM GRID ══ */}
      <section className="ot-team-sec">
        <div className="ot-container">
          <div className="ot-sec-hdr">
            <div className="ot-tag-row">
              <span className="ot-tag-line" />
              <span className="ot-tag">Core Team</span>
              <span className="ot-tag-line" />
            </div>
            <h2>The Team That Makes It Happen</h2>
            <p>
              Experienced professionals committed to operational excellence
            </p>
          </div>
          <div className="ot-grid">
            {team.map(({ name, role, initials }) => (
              <div className="ot-card" key={name}>
                <div className="ot-card-avatar">{initials}</div>
                <h3>{name}</h3>
                <span>{role}</span>
                <div className="ot-socials">
                  <a href="#">
                    <FaLinkedin />
                  </a>
                  <a href="#">
                    <FaEnvelope />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <style>{`
        .ot-page{
          font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;
          background:#ffffff;color:#101828;min-height:100vh;
        }
        .ot-container{max-width:1100px;margin:0 auto;padding:0 clamp(16px,3vw,40px);}

        /* ══ HERO ══ */
        .ot-hero-sec{
          position:relative;
          background:linear-gradient(135deg,#101636 0%,#1a1f4e 100%);
          padding:clamp(60px,10vh,100px) 0 clamp(50px,8vh,80px);
          overflow:hidden;text-align:center;
        }
        .ot-hero-bg{
          position:absolute;inset:0;
          background-image:
            radial-gradient(ellipse at 20% 50%,rgba(79,70,229,.2),transparent 50%),
            radial-gradient(ellipse at 80% 50%,rgba(245,158,11,.1),transparent 50%),
            linear-gradient(rgba(255,255,255,.03) 1px,transparent 1px),
            linear-gradient(90deg,rgba(255,255,255,.03) 1px,transparent 1px);
          background-size:100% 100%,100% 100%,50px 50px,50px 50px;
        }
        .ot-hero-content{position:relative;z-index:2;max-width:700px;margin:0 auto;padding:0 20px;}
        .ot-hero-content h1{
          font-size:clamp(1.8rem,4vw,2.8rem);font-weight:900;color:#fff;
          line-height:1.15;letter-spacing:-1px;margin-bottom:1rem;
        }
        .ot-hero-content p{color:rgba(255,255,255,.6);font-size:.9rem;line-height:1.8;max-width:500px;margin:0 auto;}

        /* Hero stats */
        .ot-hero-stats{
          display:flex;justify-content:center;gap:0;margin-top:2.5rem;
          border-top:1px solid rgba(255,255,255,.1);padding-top:1.5rem;
        }
        .ot-hstat{text-align:center;padding:0 clamp(1rem,3vw,2rem);border-right:1px solid rgba(255,255,255,.1);}
        .ot-hstat:last-child{border-right:none;}
        .ot-hstat-icon{margin:0 auto .4rem;color:#fbbf24;font-size:1.1rem;}
        .ot-hstat-num{display:block;font-size:clamp(1.1rem,2vw,1.5rem);font-weight:900;color:#fbbf24;}
        .ot-hstat-lbl{font-size:.55rem;color:rgba(255,255,255,.45);text-transform:uppercase;letter-spacing:1.5px;display:block;margin-top:2px;}

        /* Tags */
        .ot-tag-row{display:flex;align-items:center;justify-content:center;gap:14px;margin-bottom:.75rem;}
        .ot-tag-line-light{width:40px;height:1px;background:rgba(255,255,255,.2);}
        .ot-tag-light{font-size:.6rem;font-weight:800;letter-spacing:3px;text-transform:uppercase;color:#fbbf24;}
        .ot-tag-line{width:40px;height:1px;background:#c7cbe8;}
        .ot-tag{font-size:.6rem;font-weight:800;letter-spacing:3px;text-transform:uppercase;color:#4f46e5;}

        /* Section header */
        .ot-sec-hdr{text-align:center;margin-bottom:clamp(2rem,4vh,3.5rem);}
        .ot-sec-hdr h2{font-size:clamp(1.4rem,2.5vw,2.2rem);font-weight:900;color:#101828;letter-spacing:-.5px;margin-bottom:.5rem;line-height:1.2;}
        .ot-sec-hdr p{color:#6b7280;font-size:.88rem;max-width:480px;margin:0 auto;line-height:1.7;}

        /* ══ LEADERSHIP ══ */
      .ot-leaders-sec{padding:clamp(50px,8vh,90px) 0;background:#ffffff;}

      .ot-leader-block{
        display:grid;
        grid-template-columns:.85fr 1.15fr;
        gap:clamp(2rem,4vw,3.5rem);
        align-items:center;
        margin-bottom:clamp(3rem,5vh,4rem);
        padding-bottom:clamp(3rem,5vh,4rem);
        border-bottom:1px solid #eceef5;
      }

      .ot-leader-block:last-child{
        border-bottom:none;
        margin-bottom:0;
        padding-bottom:0;
      }

      .ot-leader-reverse{
        direction:rtl;
      }

      .ot-leader-reverse > *{
        direction:ltr;
      }

      /* Photo */
      .ot-leader-photo-wrap{
        position:relative;
      }

      .ot-leader-photo{
        position:relative;
        border-radius:18px;
        overflow:hidden;
        box-shadow:0 16px 40px rgba(16,24,40,.08);
        border:1px solid #e6e8f0;
      }

      .ot-leader-photo img{
        width:100%;
        height:280px;
        object-fit:cover;
        display:block;
      }

      .ot-leader-avatar{
        width:100%;
        height:280px;
        background:linear-gradient(135deg,#4f46e5,#4338ca);
        display:flex;
        align-items:center;
        justify-content:center;
        font-size:4rem;
        font-weight:900;
        color:rgba(255,255,255,.15);
        letter-spacing:4px;
      }

      /* Info */
      .ot-leader-info{
        text-align:left;
      }

      .ot-leader-role-tag{
        display:inline-block;
        font-size:.58rem;
        font-weight:800;
        letter-spacing:2.5px;
        text-transform:uppercase;
        color:#4f46e5;
        background:#eef2ff;
        padding:5px 12px;
        border-radius:999px;
        margin-bottom:.75rem;
      }

      .ot-leader-info h3{
        font-size:clamp(1.2rem,2.2vw,1.6rem);
        font-weight:900;
        color:#101828;
        letter-spacing:-.5px;
        margin-bottom:1rem;
        line-height:1.2;
      }

      .ot-leader-quote{
        background:#f8f9fc;
        border:1px solid #e6e8f0;
        border-left:4px solid #4f46e5;
        border-radius:12px;
        padding:1.25rem 1.5rem;
      }

      .ot-quote-icon{
        color:#d7dafc;
        font-size:1.2rem;
        margin-bottom:.5rem;
        display:block;
      }

      .ot-leader-quote p{
        color:#4b5266;
        font-size:.85rem;
        line-height:1.85;
        font-style:italic;
      }

        /* ══ TEAM GRID ══ */
        .ot-team-sec{padding:clamp(50px,8vh,90px) 0;background:#f8f9fc;}

        .ot-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:1.25rem;}

        .ot-card{
          background:#ffffff;border:1px solid #e6e8f0;border-radius:16px;
          padding:1.75rem 1.25rem;text-align:center;transition:all .3s;
          position:relative;overflow:hidden;
        }
        .ot-card::before{
          content:'';position:absolute;bottom:0;left:0;width:0;height:3px;
          background:linear-gradient(90deg,#4f46e5,#4338ca);transition:width .35s;
        }
        .ot-card:hover::before{width:100%;}
        .ot-card:hover{
          transform:translateY(-4px);
          box-shadow:0 14px 30px rgba(16,24,40,.08);
          border-color:#d7dafc;
        }

        .ot-card-avatar{
          width:64px;height:64px;border-radius:50%;
          background:linear-gradient(135deg,#4f46e5,#4338ca);
          color:#fff;display:flex;align-items:center;justify-content:center;
          font-weight:800;font-size:1.2rem;margin:0 auto 1rem;
          box-shadow:0 6px 18px rgba(79,70,229,.2);
        }
        .ot-card h3{font-size:.88rem;font-weight:700;color:#101828;margin-bottom:.25rem;}
        .ot-card span{font-size:.72rem;color:#6b7280;display:block;}

        .ot-socials{display:flex;justify-content:center;gap:.5rem;margin-top:1rem;}
        .ot-socials a{
          width:32px;height:32px;border-radius:8px;background:#eef2ff;
          color:#4f46e5;display:flex;align-items:center;justify-content:center;
          text-decoration:none;font-size:.8rem;transition:all .3s;
        }
        .ot-socials a:hover{background:#4f46e5;color:#fff;}

       @media(max-width:900px){
        .ot-leader-block{grid-template-columns:1fr;gap:1.5rem;}
        .ot-leader-reverse{direction:ltr;}
        .ot-leader-photo img,.ot-leader-avatar{height:240px;}
        .ot-grid{grid-template-columns:repeat(2,1fr);}
      }

      @media(max-width:768px){
        .ot-hstat{padding:0 1rem;}
      }

      @media(max-width:520px){
        .ot-grid{grid-template-columns:1fr;}
        .ot-leader-photo img,.ot-leader-avatar{height:200px;}
        .ot-hstat{width:50%;border-right:none;border-bottom:1px solid rgba(255,255,255,.08);padding:.75rem 0;}
        .ot-hero-stats{flex-wrap:wrap;}
      }
      `}</style>
    </div>
  );
}

export default OurTeam;